import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeChat, increaseCountClosedChats } from '../../actions/chatWindow';
import { unselectSubAgent } from '../../actions/masterFilters';
import { getSubAgents } from '../../actions/subAgents';
import { SelectedSubAgent } from '../../components/SelectedSubAgent';
import { useSubAgentsListOpenTracking } from '../../hooks';
import { masterFiltersSelector, subAgentsSelector } from '../../selectors';
import { useApplicationContext } from '../../utils/applicationContext';
import { isTopTabsRedesignedEnabled } from '../../utils/isTopTabsRedesignedEnabled';

export const SelectedSubAgentContainer = () => {
  const { selectedSubAgentId } = useSelector(masterFiltersSelector);
  const { subAgentsList } = useSelector(subAgentsSelector);
  const { config } = useApplicationContext();

  const isTopTabsRedesigned = isTopTabsRedesignedEnabled(config);

  const dispatch = useDispatch();

  const subAgent = subAgentsList.find(subAgent => subAgent.userId === selectedSubAgentId);

  const handleTracking = useSubAgentsListOpenTracking({ source: 'cross' });

  const handleUnselectSubAgent = React.useCallback(() => {
    dispatch(unselectSubAgent());
    dispatch(getSubAgents({}));
    dispatch(closeChat());
    dispatch(increaseCountClosedChats());
    handleTracking();
  }, [dispatch, handleTracking]);

  if (!selectedSubAgentId || !subAgent) {
    return null;
  }

  return (
    <SelectedSubAgent subAgent={subAgent} onClose={handleUnselectSubAgent} isTopTabsRedesigned={isTopTabsRedesigned} />
  );
};
